import { Factory } from "fishery";
import { BankAccountType, AchAccountOwnershipType } from "../graphql/supergraphOperations";
import type { AchPaymentPrefInputType } from "../components/PaymentPrefConsolidated/Components/AchPaymentPrefInput/constants";

export const achPaymentPrefInputFactory = Factory.define<AchPaymentPrefInputType>(() => ({
  routingNumber: "121000358",
  bankName: "Bank of Test",
  accountHolderName: "John Doe",
  accountNumber: "12345678901234567",
  confirmAccountNumber: "12345678901234567",
  accountType: BankAccountType.Checking,
  ownershipType: AchAccountOwnershipType.Business,
  additionalInstructions: "Please process this payment quickly.",
}));
